// removed by extract-text-webpack-plugin
module.exports = {"main":"lzgukgF-sJSdPeCYhRG07"};


//////////////////
// WEBPACK FOOTER
// ./pages/workspace-warehouses/containers/warehouse-setup-connecting/index.module.css
// module id = 2413
// module chunks = 0